import { sagas as enrollmentSagas } from './modules/enrollment'
import { sagas as userSagas } from './modules/user'
import { sagas as userSettingsSagas } from './modules/userSettings'

export default [...enrollmentSagas, ...userSagas, ...userSettingsSagas]
